
<template>
  <va-button class="btn alignleft" v-on:click="loginPopup">SIGN IN</va-button>
</template>